// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationDriveTrafficPath = 'M53.922 13v-1.706a3.431 3.431 0 00-3.432-3.431h-.98a3.431 3.431 0 00-3.432 3.431V13h7.844zm-14.706 0v-1.706C39.216 5.61 43.824 1 49.51 1h.98c5.685 0 10.294 4.609 10.294 10.294V13h28.647v26.47H60.784V46H82.06l17.157 13.235-17.157 13.236H60.784V99.02h-6.862V72.47h-7.844v26.55h-6.862V72.47H10.784V46h28.432v-6.53h-21.06L1 26.236 18.157 13h21.059zm6.862 26.47V46h7.844v-6.53h-7.844zm36.49-6.862H20.51l-8.334-6.373 8.334-6.372h62.059v12.745zm-2.862 33H17.647V52.863h62.059l8.333 6.372-8.333 6.373z';
var IllustrationDriveTraffic = baseIllustration('IllustrationDriveTraffic', {
  getPath: () => IllustrationDriveTrafficPath
}, 'ColoredIllustrationDriveTraffic');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationDriveTraffic;
//# sourceMappingURL=index.js.map